import React from "react";
import data from "../data/books.json";

const BooksUpcoming = ({ isBg }) => {
  const { books_other } = data;
  return (
    // <!-- ========== Books section start ========== -->
    <section
      id="books"
      className={`booksv1 section-padding  ${isBg === "yes" ? "bg-one" : ""}`}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
            <div className="section-title-center text-center">
              <span>{books_other.subtitle}</span>
              <h2 className="display-6">{books_other.title}</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>
        {books_other.books.map((book, index) => {
          const isEven = index % 2 === 0;

          const imgBlock = (
            <div
              className="col-lg-6 mb-4 mb-lg-0"
              data-aos={isEven ? "fade-right" : "fade-left"}
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <div className="row">
                <div className="col-lg-12 offset-lg-1">
                  <div className="booksv1__img--wrap">
                    <div className="booksv1__img">
                      <img
                        className="img-fluid"
                        src={book.image}
                        alt="Book name"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );

          const contentBlock = (
            <div
              className="col-lg-6"
              data-aos={isEven ? "fade-left" : "fade-right"}
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <div className="booksv1__contnet">
                <div className="booksv1__contnet--badge mb-0">
                  {book.subtitle}
                </div>
                <h3 className="display-6 m-30px-b">{book.title}</h3>
                <div className="booksv1__item--wrap">
                  <div className="booksv1__item">
                    <div className="text-muted booksv1__item--text">
                      <p dangerouslySetInnerHTML={{ __html: book.content }}></p>
                      <div>
                        <a
                          href={book.link}
                          target="_blank"
                          rel="noreferrer"
                          className="smooth button button__primary me-3"
                        >
                          <span>{book.linkText}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );

          return (
            <React.Fragment key={index}>
              {index > 0 && (
                <div className="row booksv1__separator">
                  <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
                    <div className="section-title-center text-center">
                      <div className="section-divider divider-traingle"></div>
                    </div>
                  </div>
                </div>
              )}
              <div className="row gx-5 align-items-center">
                {isEven ? (
                  <>
                    {imgBlock}
                    {contentBlock}
                  </>
                ) : (
                  <>
                    {contentBlock}
                    {imgBlock}
                  </>
                )}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </section>
    // <!-- ========== Books section end ========== -->
  );
};

export default BooksUpcoming;
